const getDate = date => {
  const dateCurrent = date && new Date(date);
  const dateText =
    dateCurrent &&
    `${dateCurrent.getDate()}/${dateCurrent.getMonth() +
      1}/${dateCurrent.getFullYear()}`;
  return dateText;
};
export default getDate;
